import React from 'react';
import classNames from 'classnames';

import css from './IconGuests.module.css';

/**
 * Map pin icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconGuests = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      width="22"
      height="22"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2359_2730)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 0C20.2435 0 24.3131 1.68571 27.3137 4.68629C30.3143 7.68687 32 11.7565 32 16C32 20.2435 30.3143 24.3131 27.3137 27.3137C24.3131 30.3143 20.2435 32 16 32C11.7565 32 7.68687 30.3143 4.68629 27.3137C1.68571 24.3131 0 20.2435 0 16C0 11.7565 1.68571 7.68687 4.68629 4.68629C7.68687 1.68571 11.7565 0 16 0Z"
          fill="#ACCABB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.0014 31.4973C18.6943 31.8317 17.3505 32.0006 16.0014 32.0001C13.2773 32.0014 10.5981 31.3066 8.21797 29.9817C5.83782 28.6568 3.83563 26.7458 2.40137 24.4299C4.32365 21.7419 7.00937 19.8584 10.4471 19.8584C16.3625 19.8584 19.4757 24.7293 19.9237 30.0779C19.9625 30.535 19.9922 31.0196 20.0037 31.495L20.0014 31.4973ZM29.8848 23.959C28.1561 26.9665 25.5003 29.3337 22.3145 30.7064C22.3831 30.4207 22.4059 30.1236 22.3785 29.8196C22.1339 26.8801 21.1442 23.8881 19.2128 21.5727C19.1087 21.4486 19.002 21.3267 18.8928 21.207C20.4338 20.4274 22.1747 20.1325 23.8866 20.3609C25.5984 20.5894 27.201 21.3306 28.4837 22.487L29.8848 23.959ZM15.9419 12.5441C15.9419 11.1832 15.4013 9.87801 14.439 8.91568C13.4766 7.95335 12.1715 7.41272 10.8105 7.41272C9.44957 7.41272 8.14437 7.95335 7.18204 8.91568C6.21971 9.87801 5.67908 11.1832 5.67908 12.5441C5.67908 13.9051 6.21971 15.2103 7.18204 16.1726C8.14437 17.1349 9.44957 17.6756 10.8105 17.6756C12.1715 17.6756 13.4766 17.1349 14.439 16.1726C15.4013 15.2103 15.9419 13.9051 15.9419 12.5441ZM22.7168 9.78301C23.2751 9.78301 23.8279 9.89297 24.3437 10.1066C24.8596 10.3203 25.3282 10.6334 25.723 11.0282C26.1178 11.423 26.431 11.8917 26.6446 12.4075C26.8583 12.9233 26.9682 13.4761 26.9682 14.0344C26.9682 14.5927 26.8583 15.1456 26.6446 15.6614C26.431 16.1772 26.1178 16.6459 25.723 17.0406C25.3282 17.4354 24.8596 17.7486 24.3437 17.9622C23.8279 18.1759 23.2751 18.2859 22.7168 18.2859C21.5892 18.2859 20.5079 17.8379 19.7106 17.0406C18.9133 16.2434 18.4654 15.162 18.4654 14.0344C18.4654 12.9069 18.9133 11.8255 19.7106 11.0282C20.5079 10.2309 21.5892 9.78301 22.7168 9.78301Z"
          fill="#13472E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2359_2730">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconGuests;
